/* eslint-disable check-file/no-index */
import { memo, Suspense } from 'react';

import { LockMobile } from '@nablax/shared/components';

import { AppProviders } from './providers';
import { AppRouter } from './router';

export const App = memo(() => {
  return (
    <AppProviders>
      <LockMobile>
        <Suspense fallback={null}>
          <AppRouter />
        </Suspense>
      </LockMobile>
    </AppProviders>
  );
});
App.displayName = 'App';
